import React, { useEffect, useState } from "react";
import Loading from "../../../../loading/Loading";
import "./StandardTemplatesList.scss";
import { CommonEnums } from "../../../../../enums/common.enums";
import VidioIcon from "../../../../../components/icons/VidioIcon";
import RightArrowIcon from "../../../../../components/icons/RightArrowIcon";
import LeftArrowIcon from "../../../../../components/icons/LeftArrowIcon";
import toast from "react-hot-toast";
import { TemplatesApi } from "../../../../../utils/api/Templates";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { useSearchParams } from "react-router-dom";
import { getImageUrl } from "../../../../../utils/helpers/common";
import RoundTrueIcon from "../../../../../components/icons/RoundTrueIcon";
import PreviewModal from "../../../workspace/propertypost/view/PreviewModal";
import PreviewCircleIcon from "../../../../../components/icons/PreviewCircleIcon";
import DownloadIcon from "../../../../../components/icons/DownloadIcon";
import { Modal } from "@mui/material";

interface stateType {
  isLoading: boolean;
  listData: any[];
  totalPage: number;
  pageNumber: number;
}

const StandardTemplatesList = ({
  selectedId,
  selectedAnnouncementSlug,
  selectedDesignTemplateStageSlug,
  postType,
  onSelectTemplate,
}: {
  selectedId: string;
  selectedAnnouncementSlug?: string;
  selectedDesignTemplateStageSlug?: string;
  postType: string;
  onSelectTemplate: (data: any) => void;
}) => {
  const [state, setState] = useState<stateType>({
    isLoading: false,
    listData: [],
    totalPage: 1,
    pageNumber: 1,
  });
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingSelection, setPendingSelection] = useState<any>(null);

  const [searchParams, setSearchParams] = useSearchParams();
  let type: any = searchParams?.get("type");
  let subscription_type: any = searchParams?.get("subscription_type");
  let listing_type: any = searchParams?.get("listing_type");
  const dispatch = useDispatch();
  const [rawApiData, setRawApiData] = useState<any[]>([]);

  let template_id = useSelector(
    (state: RootState) => state?.templates?.selectedTemplateId,
  );
  const selectedTemplateIds = useSelector(
    (state: RootState) => state.templates.selectedTemplateIds,
  );

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImages, setPreviewImages] = useState<string[]>([]);

  const announcementSlugs = [
    "announcement_for_sale_image_post",
    "announcement_for_sale_story_post",
  ];
  const isMultiSelectMode = announcementSlugs.includes(template_id);

  const checkImagetype = (type: string) => {
    let image_css = "";
    switch (type) {
      case CommonEnums?.postType?.image_post?.key:
        image_css = "image-post-template";
        break;
      case CommonEnums?.postType?.video_post?.key:
        image_css = "video-post-template";
        break;
      case CommonEnums?.postType?.story_post?.key:
        image_css = "stroy-post-template";
        break;
      case CommonEnums?.postType?.reel_post?.key:
        image_css = "reel-post-template";
        break;
      default:
        image_css = "template-image";
    }

    return image_css;
  };

  const checkVideo = (type: string) => {
    let video_check = false;
    switch (type) {
      case CommonEnums?.postType?.reel_post?.key:
        video_check = true;
        break;
      case CommonEnums?.postType?.video_post?.key:
        video_check = true;
        break;
    }

    return video_check;
  };

  const onClickPreview = () => {
    setState({
      ...state,
      pageNumber: state.pageNumber - 1,
    });
  };

  const onClickNext = () => {
    setState({
      ...state,
      pageNumber: state.pageNumber + 1,
    });
  };

  const getListApi = async (page: number) => {
    setState((prev) => ({ ...prev, isLoading: true }));

    const payload: any = {
      page,
      // template_type_id: template_id,
      post_type: postType,
      // listing_type,
      // subscription_type,
    };

    if (isMultiSelectMode && selectedAnnouncementSlug) {
      payload.announcement_type = selectedAnnouncementSlug;
    }

    const res = await TemplatesApi.getStandardTemplates(payload);

    if (res?.data?.success) {
      setRawApiData(res.data.data.docs);
      setState((prev) => ({
        ...prev,
        isLoading: false,
        totalPage: res.data.data.totalPages,
      }));
    } else {
      setState((prev) => ({ ...prev, isLoading: false }));
      toast.error(res?.data?.message);
    }
  };

  useEffect(() => {
    getListApi(state.pageNumber);
  }, [state.pageNumber, template_id, selectedAnnouncementSlug]);

  useEffect(() => {
    const updatedList = rawApiData.map((template: any) => ({
      ...template,
      // selected: isMultiSelectMode
      //   ? selectedTemplateIds.includes(template._id)
      //   : template._id === selectedId,
      selected: false,
    }));

    setState((prev) => ({
      ...prev,
      listData: updatedList,
    }));
  }, [rawApiData, selectedTemplateIds, selectedId, isMultiSelectMode]);

  // const onTemplateSelect = (selectedTemplateId: string) => {
  //   if (!isMultiSelectMode) {
  //     const updatedList = state.listData.map((item) => ({
  //       ...item,
  //       selected: item._id === selectedTemplateId,
  //     }));
  //     setState((prev) => ({
  //       ...prev,
  //       listData: updatedList,
  //     }));
  //   }
  // };

  const onTemplateSelect = (item: any) => {
    if (!isMultiSelectMode) {
      onSelectTemplate(item);

      const updatedList = state.listData.map((data) => ({
        ...data,
        selected: data._id === item._id,
      }));

      setState((prev) => ({
        ...prev,
        listData: updatedList,
      }));
    }
  };

  const handleConfirmMasterDesign = async () => {
    try {
      const payload: any = {
        post_type: type,
        design_record_id: pendingSelection._id,
      };

      const res = await TemplatesApi.setTemplate(payload);

      if (res?.data?.success) {
        const updatedList = state.listData.map((item) => ({
          ...item,
          selected: item._id === pendingSelection._id,
        }));

        setState((prev) => ({
          ...prev,
          listData: updatedList,
        }));

        toast.success("Master design updated!");
        setShowConfirmModal(false);
      } else {
        toast.error(res?.data?.message || "Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error updating master design");
    }
  };

  const handleCardClick = (data: any) => {
    const mediaPath = checkVideo(data.post_type)
      ? data?.template_video_ref?.compressed_file_path
      : data?.template_image_ref?.compressed_file_path;

    if (mediaPath) {
      setPreviewImages([getImageUrl(mediaPath)]);
      setPreviewOpen(true);
    }
  };

  return (
    <div className="standard-templates-list-container">
      {state?.isLoading ? (
        <div className="list-page-loading">
          <Loading />
        </div>
      ) : state?.listData?.length === 0 ? (
        <div className="data-not-found">
          <p>Templates not found !</p>
        </div>
      ) : (
        <div className="select-design-template-container">
          {state?.listData?.map((data: any) => (
            <div
              className={`template-card-wrapper ${data.selected ? "selected-card" : ""}`}
              key={data?._id}
            >
              <div className="template-header-bar">
                <p className="template-name">{data?.name}</p>
                <button
                  className={`select-btn ${data.selected ? "selected" : ""}`}
                  onClick={() => onTemplateSelect(data)}
                >
                  {data.selected ? "Selected" : "Select"}
                </button>
              </div>

              <div className="template-preview-row">
                <div className="post-column">
                  <div className="image-post-box">
                    <img
                      src={getImageUrl(
                        data?.image_post_master_design_svg_file
                          ?.original_file_path,
                      )}
                      alt="Image Post"
                    />
                  </div>
                  <div className="post-footer">
                    <span>Image Post</span>
                    <div className="footer-icons">
                      <DownloadIcon />
                      <PreviewCircleIcon />
                    </div>
                  </div>
                </div>

                <div className="post-column">
                  <div className="story-post-box">
                    <div className="story-inner-img">
                      <img
                        src={getImageUrl(
                          data?.story_post_master_design_svg_file
                            ?.original_file_path,
                        )}
                        alt="Story Post"
                      />
                    </div>
                  </div>
                  <div className="post-footer">
                    <span>Story Post</span>
                    <div className="footer-icons">
                      <DownloadIcon />
                      <PreviewCircleIcon />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {showConfirmModal && (
        <Modal
          open={showConfirmModal}
          onClose={() => setShowConfirmModal(false)}
          className="master-design-modal-wrapper"
        >
          <div className="master-confirm-container">
            <h3>Set as Master Design?</h3>
            <p className="modal-subtitle">
              All future marketing assets will be generated based on this master
              design setup. You can customize these designs at any time after
              confirmation.
            </p>

            <div className="modal-preview-section">
              <div className="template-header-bar mini">
                <p className="template-name">{pendingSelection?.name}</p>
              </div>

              <div className="template-preview-row">
                <div className="post-column">
                  <div className="image-post-box">
                    <img
                      src={getImageUrl(
                        pendingSelection?.image_post_master_design_svg_file
                          ?.original_file_path,
                      )}
                      alt="Preview"
                    />
                  </div>
                  <div className="post-footer">
                    <span>Image Post</span>
                    <div className="footer-icons">
                      <DownloadIcon />
                      <PreviewCircleIcon />
                    </div>
                  </div>
                </div>

                <div className="post-column">
                  <div className="story-post-box">
                    <div className="story-inner-img">
                      <img
                        src={getImageUrl(
                          pendingSelection?.story_post_master_design_svg_file
                            ?.original_file_path,
                        )}
                        alt="Preview"
                      />
                    </div>
                  </div>
                  <div className="post-footer">
                    <span>Story Post</span>
                    <div className="footer-icons">
                      <DownloadIcon />
                      <PreviewCircleIcon />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <p className="final-confirmation-text">
              Would you like to set this as the master design?
            </p>

            <div className="modal-action-btns">
              <button
                className="btn-cancel"
                onClick={() => setShowConfirmModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn-confirm"
                onClick={handleConfirmMasterDesign}
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal>
      )}

      {state?.totalPage !== 1 && (
        <div className="template-list-pagination">
          <button
            className="preview-box pagination-button"
            onClick={onClickPreview}
            disabled={state?.pageNumber === 1 ? true : false}
          >
            <LeftArrowIcon />
          </button>
          <div className="pagination-page-no">
            <p>
              Page {state?.pageNumber} of {state.totalPage}
            </p>
          </div>
          <button
            className="next-box pagination-button"
            onClick={onClickNext}
            disabled={state?.pageNumber === state.totalPage ? true : false}
          >
            <RightArrowIcon />
          </button>
        </div>
      )}

      <PreviewModal
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        images={previewImages}
      />
    </div>
  );
};

export default StandardTemplatesList;

const selectTemplatesData = [
  {
    id: "1",
    title: "V1:Template 01",
    active: false,
    imgSrc: "/images/Template01.png",
    type: CommonEnums?.postType?.image_post?.key,
  },
  {
    id: "2",
    title: "V1:Template 02",
    active: false,
    imgSrc: "/images/Template01.png",
    type: CommonEnums?.postType?.video_post?.key,
  },

  {
    id: "3",
    title: "V1:Template 03",
    active: true,
    imgSrc: "/images/Template02.png",
    type: CommonEnums?.postType?.reel_post?.key,
  },

  {
    id: "4",
    title: "V1:Template 04",
    active: false,
    imgSrc: "/images/Template02.png",
    type: CommonEnums?.postType?.story_post?.key,
  },
];

const tempListData = [
  {
    _id: "67c19baff7530bc9fe11c76b",
    name: "Template 01",
    subscription_type: "property_marketing",
    post_type: "image_post",
    subscription_plan: "67c19b20f7530bc9fe11c721",
    template_type: "67bfb108885662bf13aa8934",
    template_image:
      "files/design-templates/images/original/d57c99d0-f5c5-11ef-b997-936e077d2a9e-1740741551085.png",
    template_image_ref: {
      _id: "67c19baff7530bc9fe11c767",
      file_name: "Rectangle 1083",
      file_type: "image/png",
      file_size: 431531,
      compressed_file_path:
        "files/design-templates/images/compressed/d57c99d0-f5c5-11ef-b997-936e077d2a9e-1740741551085.png",
      original_file_path:
        "files/design-templates/images/original/d57c99d0-f5c5-11ef-b997-936e077d2a9e-1740741551085.png",
      filepath_on_design_automation_server: "",
      createdAt: "2025-02-28T11:19:11.707Z",
      updatedAt: "2025-02-28T11:19:11.707Z",
      __v: 0,
    },
    template_video_ref: null,
    template_file:
      "files/design-templates/d57ce7f0-f5c5-11ef-b997-936e077d2a9e-1740741551087.ai",
    template_file_ref: "67c19baff7530bc9fe11c769",
    is_personalized: false,
    personalized_user: null,
    personalized_ref_model: null,
    status: "active",
    createdAt: "2025-02-28T11:19:11.880Z",
    updatedAt: "2025-02-28T11:19:11.880Z",
    __v: 0,
    id: "67c19baff7530bc9fe11c76b",
    selected: true,
  },

  {
    _id: "67c19baff7530bc9fe11c762",
    name: "Template 01",
    subscription_type: "property_marketing",
    post_type: "image_post",
    subscription_plan: "67c19b20f7530bc9fe11c721",
    template_type: "67bfb108885662bf13aa8934",
    template_image:
      "files/design-templates/images/original/d57c99d0-f5c5-11ef-b997-936e077d2a9e-1740741551085.png",
    template_image_ref: {
      _id: "67c19baff7530bc9fe11c767",
      file_name: "Rectangle 1083",
      file_type: "image/png",
      file_size: 431531,
      compressed_file_path:
        "files/design-templates/images/compressed/d57c99d0-f5c5-11ef-b997-936e077d2a9e-1740741551085.png",
      original_file_path:
        "files/design-templates/images/original/d57c99d0-f5c5-11ef-b997-936e077d2a9e-1740741551085.png",
      filepath_on_design_automation_server: "",
      createdAt: "2025-02-28T11:19:11.707Z",
      updatedAt: "2025-02-28T11:19:11.707Z",
      __v: 0,
    },
    template_video_ref: null,
    template_file:
      "files/design-templates/d57ce7f0-f5c5-11ef-b997-936e077d2a9e-1740741551087.ai",
    template_file_ref: "67c19baff7530bc9fe11c769",
    is_personalized: false,
    personalized_user: null,
    personalized_ref_model: null,
    status: "active",
    createdAt: "2025-02-28T11:19:11.880Z",
    updatedAt: "2025-02-28T11:19:11.880Z",
    __v: 0,
    id: "67c19baff7530bc9fe11c76b",
    selected: false,
  },

  {
    _id: "67c19baff7530bc9fe11c765",
    name: "Template 01",
    subscription_type: "property_marketing",
    post_type: "image_post",
    subscription_plan: "67c19b20f7530bc9fe11c721",
    template_type: "67bfb108885662bf13aa8934",
    template_image:
      "files/design-templates/images/original/d57c99d0-f5c5-11ef-b997-936e077d2a9e-1740741551085.png",
    template_image_ref: {
      _id: "67c19baff7530bc9fe11c767",
      file_name: "Rectangle 1083",
      file_type: "image/png",
      file_size: 431531,
      compressed_file_path:
        "files/design-templates/images/compressed/d57c99d0-f5c5-11ef-b997-936e077d2a9e-1740741551085.png",
      original_file_path:
        "files/design-templates/images/original/d57c99d0-f5c5-11ef-b997-936e077d2a9e-1740741551085.png",
      filepath_on_design_automation_server: "",
      createdAt: "2025-02-28T11:19:11.707Z",
      updatedAt: "2025-02-28T11:19:11.707Z",
      __v: 0,
    },
    template_video_ref: null,
    template_file:
      "files/design-templates/d57ce7f0-f5c5-11ef-b997-936e077d2a9e-1740741551087.ai",
    template_file_ref: "67c19baff7530bc9fe11c769",
    is_personalized: false,
    personalized_user: null,
    personalized_ref_model: null,
    status: CommonEnums?.status?.disable,
    createdAt: "2025-02-28T11:19:11.880Z",
    updatedAt: "2025-02-28T11:19:11.880Z",
    __v: 0,
    id: "67c19baff7530bc9fe11c76b",
    selected: true,
  },
];
